import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/yahoo': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M252 292l4 220c-12.7-2.2-23.5-3.9-32.3-3.9-8.4 0-19.2 1.7-32.3 3.9l4-220c-55-94.8-110.4-196.8-174-292 11.9 3.1 23 3.9 33.2 3.9 9 0 20.4-0.8 34.1-3.9 40.9 72.2 82.1 138.7 135 225.5 37.3-61.6 91.1-144.1 134.9-225.5 11.1 2.9 22 3.9 32.9 3.9 11.5 0 23.2-1 35-3.9-34.4 47.9-131.6 216.9-174.5 292z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/yahoo.js
// module id = 1106
// module chunks = 0